


























import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Button, Table, TableColumn, Scrollbar, Loading, Message, DatePicker, Progress,
} from 'element-ui';
import Read from '@/servers/modules/read/read'; // server
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';

    @Component({
      components: {
        Table,
        TableColumn,
        Progress,
        Scrollbar
      },
    })
export default class extends Vue {
        private percentage:any = 0;

        private pageNum: number = 1;

        private tableData:any = [];

        private data:any = [];

        private async init() {
          const res = await Read.queryAcademicAnalysis().catch((e:any) => {
            console.log(e);
          });
          if (!res.data.code) {
            this.data = res.data.data;
            this.percentage = (this.data.earnedPoints) / (this.data.sumQuestionCount) * 100;
            this.tableData = this.tableData.concat(res.data.data.unitCorrectRateStatistics);
          }
        }

        private async load() {
          this.pageNum = ++this.pageNum;
          this.init();
        }

        private created() {
          // title
          this.title = '';// window.LS.get('vteData').course.courseTitle;
          this.pageNum;
          this.init();
        }

        private tableHeaderClassName() {
          return 'table-header';
        }

        private tableRowClassName() {
          return 'table-row';
        }
}
